import "core-js/modules/es6.string.starts-with";
import "@ykz/ykz-ui/lib/loading/style.css";
import _Loading from "@ykz/ykz-ui/lib/loading";
import "@ykz/ykz-ui/lib/button/style.css";
import _Button from "@ykz/ykz-ui/lib/button";
import "core-js/modules/es6.function.name";
import "@ykz/ykz-ui/lib/dialog/style.css";
import _Dialog from "@ykz/ykz-ui/lib/dialog";
import { updateUrlParam, toast } from '@ykz/ykz-util/base';
import { copy } from '@ykz/ykz-util/platform';
import Databus, { Origins } from '@ykz/ykz-http/core';
import { getUserPromotion } from '@ykz/ykz-http/common';
Vue.component(_Dialog.name, _Dialog);
Vue.component(_Button.name, _Button);
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    goodId: {
      type: String,
      default: ''
    },
    couponDetail: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    posterLink: {} //生成海报图所需的链接，商详页传
  },
  data: function data() {
    return {
      generated: false,
      articleUrl: '',
      posterImg: '',
      noChance: false
    };
  },
  watch: {
    value: function value(newV) {
      if (newV && !this.generated) {
        this.getLinkStatus();
      }
    }
  },
  methods: {
    handleCopyLink: function handleCopyLink() {
      copy(this.articleUrl).success(function () {
        toast('复制成功！');
      }).fail(function () {
        toast('复制失败，请重试！');
      });
    },
    getLinkStatus: function getLinkStatus() {
      var that = this;
      return new Promise(function (resolve, reject) {
        Databus({
          url: '/api/wechatChannel/getGenLinkStatus',
          type: 'get',
          origin: Origins.API_MARKETING,
          data: {
            goodsId: that.goodId
          },
          success: function success(res) {
            if (res.code == 1000 && res.bcode == 100) {
              if (res.content.try_count_left <= 0) {
                that.noChance = true;
              }
              if (res.content.article_url) {
                that.articleUrl = res.content.article_url;
                that.generated = true;
              }
              resolve();
            } else {
              reject();
            }
          },
          error: function error() {
            toast('网络有误，请重试');
            reject();
          }
        });
      });
    },
    handleGenerate: function handleGenerate() {
      var _this = this;
      var that = this;
      if (this.generated) {
        return;
      }
      if (this.noChance) {
        toast('本日专属次数已用完');
        return;
      }
      this.getPoster().then(function () {
        getUserPromotion().then(function (promotion) {
          var url = updateUrlParam(that.posterLink, 'promotion', promotion);
          Databus({
            url: '/api/wechatChannel/genLinkByGoodsId',
            type: 'get',
            origin: Origins.API_MARKETING,
            data: {
              goodsId: _this.goodId,
              goodsUrl: encodeURIComponent(url),
              posterUrl: encodeURIComponent(_this.posterImg)
            },
            success: function success(res) {
              if (res.code == 1000 && res.bcode == 100) {
                that.articleUrl = res.content.article_url;
                that.generated = true;
              } else {
                toast(res.message || '生成链接失败');
              }
            },
            error: function error() {
              toast('网络有误，请重试');
            },
            beforeSend: function beforeSend() {
              _Loading.show('预计10秒左右生成');
            },
            complete: function complete() {
              _Loading.hide();
            }
          });
        });
      });
    },
    //生成海报图
    getPoster: function getPoster() {
      var _this2 = this;
      var that = this;
      return new Promise(function (resolve, reject) {
        if (_this2.posterImg) {
          return resolve(_this2.posterImg);
        }
        Databus({
          url: '/apiv2/marketing/getPoster',
          type: 'get',
          data: {
            type: 1,
            storeId: that.couponDetail.isStore && that.couponDetail.storeData && that.couponDetail.storeData.storeId || '',
            productId: that.goodId,
            url: that.posterLink || '',
            rateplan: getUrlParams('rateplan') || '',
            //价格计划加密串
            saleNum: that.couponDetail.labelType == 1 ? that.couponDetail.saleNum : 0,
            //销量
            activityEndTime: that.activityId ? that.couponDetail.queueEndTime : null //活动结束时间戳
          },
          success: function success(res) {
            if (res.code == 1000 && res.bcode == 100) {
              var data = res.content || {};
              if (data.posterImg) {
                var img = data.posterImg instanceof Array ? data.posterImg[0] : data.posterImg;
                that.posterImg = img.startsWith('//') ? 'https:' + img : img;
              } else {
                that.posterImg = '';
              }
              resolve();
            } else {
              reject();
            }
          },
          error: function error() {
            reject();
          },
          beforeSend: function beforeSend() {
            _Loading.show();
          },
          complete: function complete() {
            _Loading.hide();
          }
        });
      });
    }
  }
};